import { Component, Input, Output, ViewChild, EventEmitter } from "@angular/core";
import { UserFiaPins } from 'src/app/shared/models/users/user-fia-pins';
import { SettingsService } from "src/app/services/settings.service";
import { UserService } from "src/app/services/user.service";
import { UserFullDetails } from "src/app/shared/models/users/user-full-details";

@Component({
    selector: 'app-fia-pins',
    templateUrl: './fia-pins.component.html',
    styleUrls: ['./fia-pins.component.scss']
})
export class FiaPinsComponent {

    @ViewChild('fiaPinsModal', { static: true }) fiaPinsModal: any;

    @Input() showMe: boolean = false;    
    @Output() showMeChange = new EventEmitter<boolean>();

    busy: boolean = false;
    showError: boolean = false;
    errorMessage: string = "";
    userDetails: UserFullDetails = new UserFullDetails();
    userFiaPins: UserFiaPins[] = [];
    totalAmountAvailable: number = 0;

    constructor(public settingsSerivce: SettingsService, public userService: UserService) {
        
    }

    ngOnChanges(): void {
        this.showHideMe(null);
    }

    onClosed(event: any) {
        if (this.showMe != false) {            
            this.showMe = false;
            this.showMeChange.emit(this.showMe);
        }
    }

    showHideMe(toggle: boolean) {                
        if (toggle != null) {
            this.showMe = toggle;
        }

        if (this.showMe) {
            this.GetUserData(this.settingsSerivce.userId);
            this.GetFiaData(this.settingsSerivce.userId);
            this.fiaPinsModal.show();
        } else {
            this.userDetails = null;
            this.userFiaPins = [];
            this.fiaPinsModal.hide();
        }        

        this.showMeChange.emit(this.showMe);
    }

    GetUserData(userid: number) {
        this.busy = true;
        return new Promise(resolve => {      
            this.userService.GetUserDetails(userid).subscribe(
                (response) => {
                    this.userDetails = response;
                    this.showError = false;
                    this.busy = false;
                    resolve(true);
                },
                (error) => {
                    this.showError = true;
                    this.errorMessage = "Oops: " + error.error.title + " while trying to get your user data";
                    this.busy = false;
                    resolve(true);
                }
            );
        });        
    }

    GetFiaData(userid: number) {  
        this.busy = true;
        return new Promise(resolve => {
            this.userService.GetUsersFiaPins(userid).subscribe(
                (response) => {
                    this.userFiaPins = response;
                    this.totalAmountAvailable = UserFiaPins.calculatePinAvailableAmount(this.userFiaPins);
                    this.showError = false;
                    this.busy = false;                    
                    resolve(true);
                },
                (error) => {
                    this.showError = true;
                    this.errorMessage = "Oops: " + error.error.title + " while trying to get your FIA pins data";
                    this.busy = false;
                    resolve(true);
                }
            )
        });
    }

    canEdit(pin: any) {

    }

    editPinClicked(pin: any) {

    }

    SavePin() {

    }
}